// Source - https://stackoverflow.com/a
// Posted by Lucas Andrade, modified by community. See post 'Timeline' for change history
// Retrieved 2025-12-01, License - CC BY-SA 4.0

import { Routes, Route } from 'react-router-dom';

import Splash from './Splash';
import About from './About';
import NotFound from './NotFound';
import Battledrift from './BATTLEDRIFT';
import BattledriftDemo from './BattledriftDemo';

const Main = () => {
  return (
    <Routes> {/* The Switch decides which component to show based on the current URL.*/}
      <Route exact path='/' element={<Splash />}></Route>
      <Route exact path='/About' element={<About />}></Route>
      <Route path='/BATTLEDRIFT' element={<Battledrift />}></Route>
      <Route path='/BATTLEDRIFT-DEMO' element={<BattledriftDemo />}></Route>
      <Route path='*' element={<NotFound />}></Route>
    </Routes>
  );
}

export default Main;
